import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useMemo } from "react";
import { useCommonDataContext } from "@core/CommonDataContext";
import { HEAT_SCORE_COLORS, HeatScore } from "@models/HeatScore";

type Modifiers = 'small' | 'medium';

const HeatScoreLabel: FCX<{
    heatScoreId: HeatScore;
    modifiers?: Modifiers[];
}> = ({
    heatScoreId,
    modifiers = [],
    className,
    children,
    testId,
    ...props
}) => {
    const { heatScores } = useCommonDataContext();

    const heatScore = useMemo(
        () => {
            const option = (heatScores ?? []).find(
                (stage) => stage.id === heatScoreId
            );

            if (option) {
                return {
                    ...option,
                    ...HEAT_SCORE_COLORS[heatScoreId ?? HeatScore.NoData],
                }
            }
        },
        [heatScoreId, heatScores]
    );

    if (!heatScore) {
        return null;
    }

    return (
        <div
            className={cn(
                'HeatScoreLabel',
                className,
                ...modifiers.map((m) => `is-${m}`),
            )}
            data-testid={testId}
            {...props}
            style={{
                color: heatScore.color,
                backgroundColor: heatScore.bgColor,
            }}
        >
            {heatScore.name}
        </div>
    );
};

export default HeatScoreLabel;